import React from 'react';

import Button from 'antd/es/button';
import MainModal from '../MainPage/MainModal';

export const NonUSARestrictModal = ({ modalVisible, setModalVisible, mobileView }: $TSFixMe) => {
  return (
    <MainModal
      width={mobileView ? 350 : 600}
      title='We are unable to create an account for you.'
      maskClosable
      closable={false}
      onCancel={() => setModalVisible(false)}
      visible={modalVisible}>
      <>
        <p className='mt-lg font-15'>
          Please reach out to <a href='mailto:supportexp@attentive.ai'>supportexp@attentive.ai</a> with details on how
          Attentive could help your business.
        </p>
        <div className='mt-lg text-center'>
          <Button ghost className='mr' type='primary' size='small' onClick={() => setModalVisible(false)}>
            Go back
          </Button>
        </div>
      </>
    </MainModal>
  );
};
